const NetworkTypes = Object.freeze({
  InsuranceMarket: 1,
  Affinity: 2,
  Pro: 3,
});

export { NetworkTypes };
